import { render, staticRenderFns } from "./schemeMuti.vue?vue&type=template&id=2f90f74c&scoped=true"
import script from "./schemeMuti.vue?vue&type=script&lang=js"
export * from "./schemeMuti.vue?vue&type=script&lang=js"
import style0 from "./schemeMuti.vue?vue&type=style&index=0&id=2f90f74c&prod&lang=stylus"
import style1 from "./schemeMuti.vue?vue&type=style&index=1&id=2f90f74c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90f74c",
  null
  
)

export default component.exports